import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';
import IPageViewModel from '../../interfaces/umbracoNodes/pageViewModel';
import Accordion from '../accordion';
import { IAccordionItem } from '../accordion/accordion';
import * as StyledQuestionsAndAnswers from './questionsAndAnswers.styles';

interface Props {
	items: IPageViewModel[];
}

const QuestionsAndAnswers: FC<Props> = ({ items }) => {
	const { t } = useTranslation('common');
	const accordionItems: IAccordionItem[] = items.map(item => ({
		Values: {
			PageTitle: item.Values.PageTitle,
			Title: item.Name,
			Content: item.Values.Answer,
		},
		id: uuidv4(),
	}));

	const table = [];
	accordionItems.forEach(item => table.push({ id: item.id, title: item.Values.Title }));

	return (
		<StyledQuestionsAndAnswers.Wrapper>
			<Accordion title={t('misc.questions-and-answers')} items={accordionItems} />
		</StyledQuestionsAndAnswers.Wrapper>
	);
};

export default QuestionsAndAnswers;
